import { useCallback, useState } from 'react';
import { PROMOTION_DEFAULT_GOAL_ID } from '../../../../../constant';
// eslint-disable-next-line no-restricted-imports
import { DirectMetricsGoalUI } from '../../../../../data-layer/direct/types';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ContentPromotionGoalsDialog } from '../../../ContentPromotionGoalsDialog/ContentPromotionGoalsDialog';
import { ContentPromotionBudgetGoal } from '../ContentPromotionBudgetGoal/ContentPromotionBudgetGoal';
import { AddGoalButton, Wrapper } from './styles';
import { ContentPromotionBudgetGoalsProps } from './types';

export const ContentPromotionBudgetGoals: React.FC<ContentPromotionBudgetGoalsProps> = ({
    goals: goalsBase,
    selectedCounters,
    selectedGoals,
    hiddenBudgetValue,
    showCostType,
    requiredCost,
    onSelect,
    onRemove,
    onChange,
    onChangeCostType,
    ...other
}) => {
    const t = useTranslation();

    const [visibleGoalsDialog, setVisibleGoaldDialog] = useState(false);
    const closeGoalsDialog = useCallback(() => setVisibleGoaldDialog(false), []);
    const openGoalsDialog = useCallback(() => setVisibleGoaldDialog(true), []);

    const goals = goalsBase.filter((goal) => selectedCounters.indexOf(goal.counterId) !== -1);
    const selectedGoalsIds = selectedGoals && Object.keys(selectedGoals);
    const selected = selectedGoalsIds?.reduce<DirectMetricsGoalUI[]>((result, id: string) => {
        const goal =
            id === PROMOTION_DEFAULT_GOAL_ID
                ? {
                      counterId: '',
                      id,
                      name: t('Вовлеченные сессии'),
                  }
                : goals.find((goalData) => goalData.id === id);

        if (goal) {
            result.push(goal);
        }

        return result;
    }, []);

    return (
        <>
            <Wrapper {...other}>
                <Flex direction="row" alignItems="center">
                    <Typography variant="body" weight="bold">
                        {t('Целевые действия и их цена')}
                    </Typography>
                </Flex>
                <Typography variant="body" pt={2}>
                    {t(
                        'Добавьте хотя бы по одной цели со счётчика для сайта — это нужно для подбора наиболее конверсионного трафика',
                    )}
                </Typography>
                {selected ? (
                    <Flex width="100%" pt={1}>
                        {selected.map((goal) => (
                            <ContentPromotionBudgetGoal
                                key={goal.id}
                                py={2}
                                goal={goal}
                                hiddenRemoveButton={
                                    goal.id === PROMOTION_DEFAULT_GOAL_ID &&
                                    selectedGoalsIds?.length === 1
                                }
                                value={selectedGoals?.[goal.id].cost}
                                costType={selectedGoals?.[goal.id].costType}
                                hiddenValue={hiddenBudgetValue}
                                required={requiredCost}
                                showCostType={showCostType}
                                onRemove={onRemove}
                                onChange={onChange}
                                onChangeCostType={onChangeCostType}
                            />
                        ))}
                    </Flex>
                ) : null}
                <AddGoalButton mt={2} disabled={!goals.length} onClick={openGoalsDialog}>
                    {t('Добавить цель')}
                </AddGoalButton>
            </Wrapper>
            {visibleGoalsDialog ? (
                <ContentPromotionGoalsDialog
                    goals={goals}
                    selected={selectedGoalsIds}
                    onSelect={onSelect}
                    onClose={closeGoalsDialog}
                />
            ) : null}
        </>
    );
};
